import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom"
import { Icon } from '@chakra-ui/react'
import { VscAccount } from "react-icons/vsc"
import { IoIosCall } from "react-icons/io"
import { IoMdPeople } from "react-icons/io"
import { IoMdCard } from "react-icons/io"
import AuthService from "../../../services/auth.service";
import classes from "./DataPribadi/styles.module.css";

import {
    Button,
    Box,
    Center,
    Heading,
    Text,
    VStack,
} from '@chakra-ui/react';

export default class ProfilPeserta extends Component {

    constructor(props) {
        super(props);
        this.state = {
          content: "",
          redirect: null,
          userReady: false,
          currentUser: {peserta: []}
        };
    }

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
    
        if (!currentUser) this.setState({ redirect: "/" });
        this.setState({ currentUser: currentUser, userReady: true })
    }

    render() {
        if (this.state.redirect) {
            return <Link to={this.state.redirect} />
          }
      
        const { currentUser } = this.state;
        return (
            <Center>
            <VStack justifyItems='left'>
                <Text
                    paddingBottom={10}
                    color={'gray.700'}
                    fontWeight={600}
                    fontSize={'xl'}
                    fontFamily={'Inter'}>
                    Lihat / Edit Profil
                </Text>
                <Box
                    m='10px'
                    w='400px'
                    border='1px'
                    borderColor='gray.200'
                    alignContent='flex-start'
                    justifyContent='left'
                    bg={'white'}
                    rounded={'2xl'}
                    p={6}
                    className={classes.box}
                    overflow={'hidden'}>
                    {currentUser.peserta && currentUser.peserta.map((data) =>
                    <VStack>
                        <Button 
                            as={Link} to={`/peserta/profile/datapribadi/${data.idPeserta}`}
                            colorScheme='purple' rounded={'2xl'} h='60px' justifyContent='left' w='100%' variant='ghost'>
                            <Icon mr="16px" fontSize={'2xl'} as={VscAccount} />
                            <Heading
                                color={'gray, 800'}
                                fontSize={'l'}
                                fontFamily={'Inter'}>
                                Data Diri
                            </Heading>
                        </Button>
    
                        <Button 
                            as={Link} to={`/peserta/profile/kontak/${data.idPeserta}`}
                            rounded={'2xl'} h='60px' justifyContent='left' w='100%' colorScheme='purple' variant='ghost'>
                            <Icon mr="16px" fontSize={'2xl'} as={IoIosCall} />
                            <Heading
                                color={'gray, 800'}
                                fontSize={'l'}
                                fontFamily={'Inter'}>
                                Kontak Pribadi
                            </Heading>
                        </Button>
        
                        <Button 
                            as={Link} to={`/peserta/profile/mediasosial/${data.idPeserta}`}
                            rounded={'2xl'} h='60px' justifyContent='left' w='100%' colorScheme='purple' variant='ghost'>
                            <Icon mr="16px" fontSize={'2xl'} as={IoMdPeople} />
                            <Heading
                                color={'gray, 800'}
                                fontSize={'l'}
                                fontFamily={'Inter'}>
                                Media Sosial
                            </Heading>
                        </Button>
        
                        <Button 
                            as={Link} to={`/peserta/profile/rekening/${data.idPeserta}`}
                            rounded={'2xl'} h='60px' justifyContent='left' w='100%' colorScheme='purple' variant='ghost'>
                            <Icon mr="16px" fontSize={'2xl'} as={IoMdCard} />
                            <Heading
                                color={'gray, 800'}
                                fontSize={'l'}
                                fontFamily={'Inter'}>
                                Detail Rekening
                            </Heading>
                        </Button>
                    </VStack>)}
                </Box>
            </VStack>
            </Center>
        );
    }
}
